// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .cz2__steps-option{pointer-events:auto}#cz2.cz2 .cz2__steps-option .selection-category-list{overflow:auto;display:flex;flex-direction:column;gap:var(--layout-gap)}#cz2.cz2 .cz2__steps-option .selection-category-list .cz2__disclaimer{margin:16px 0 -8px var(--layout-spacing)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
